import { render, staticRenderFns } from "./OffsiteContacts.vue?vue&type=template&id=8c745464&"
import script from "./OffsiteContacts.vue?vue&type=script&lang=js&"
export * from "./OffsiteContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports